import { importTypes } from './importTypes';

export const instructions = {
  [importTypes.owners]: {
    name: 'Инструкция (собственники).pdf',
    url: 'Request/get_instruction_owners',
    errMsg: 'Не удалось получить инструкцию для импорта собственников',
  },

  [importTypes.personalAccounts]: {
    name: 'Инструкция (лицевые счета).pdf',
    url: 'Request/instruction_accounts',
    errMsg: 'Не удалось получить инструкцию для импорта лицевых счетов',
  },

  [importTypes.individualMeters]: {
    name: 'Инструкция (ИПУ).pdf',
    url: 'Meter/mass_load_instruction',
    errMsg: 'Не удалось получить инструкцию для импорта ИПУ',
  },
};
